var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7813 9.29599L9.29599 17.7813C10.148 18.6333 10.1267 20.0362 9.24778 20.915C8.3689 21.7939 6.966 21.8152 6.11401 20.9633C5.5774 20.4266 5.38708 19.6718 5.53944 18.9665C4.83415 19.1189 4.07932 18.9286 3.54271 18.392C2.69072 17.54 2.71205 16.1371 3.59092 15.2582C4.4698 14.3793 5.8727 14.358 6.72469 15.21L15.21 6.72469C14.358 5.8727 14.3793 4.4698 15.2582 3.59092C16.1371 2.71205 17.54 2.69072 18.392 3.54271C18.9286 4.07932 19.1189 4.83415 18.9665 5.53944C19.6718 5.38708 20.4266 5.5774 20.9633 6.11401C21.8152 6.966 21.7939 8.3689 20.915 9.24778C20.0362 10.1267 18.6333 10.148 17.7813 9.29599Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBone);
export default __webpack_public_path__ + "static/media/Bone.9adc8b6e76e8b78bb9c39839c122dee4.svg";
export { ForwardRef as ReactComponent };